module.exports = __webpack_public_path__ + "static/img/19034C_1_2_C_20220309_fit.ad29a73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19034C_1_2_C_20220309_fit.png
// module id = UNai
// module chunks = 0